// extracted by mini-css-extract-plugin
module.exports = {"paddleCheckout":"PaddleCheckout_paddleCheckout__wLusf"};